import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CommunityUpdateResponseLayer from "../components/CommunityUpdateResponseLayer";

const CommunityUpdateResponsePage = () => {
    return (
        <MasterLayout>
            <CommunityUpdateResponseLayer />
        </MasterLayout>
    );
};

export default CommunityUpdateResponsePage;
